import imageCompression from 'browser-image-compression';

/**
 * Compresses an image file.
 * @param {File} imageFile - The original image file.
 * @returns {Promise<File>} - The compressed image file.
 */
export const compressImage = async (imageFile, customOptions = {}) => {
    const defaultOptions = {
        maxSizeMB: 0.5,           // Default Max size in MB
        maxWidthOrHeight: 1920,   // Default Max width or height
        useWebWorker: true,      // Use web worker for better performance
        fileType: imageFile.type // Maintain original file type
    };

    const options = { ...defaultOptions, ...customOptions };

    try {
        console.log(`Original file size: ${(imageFile.size / 1024 / 1024).toFixed(2)} MB`);
        const compressedFile = await imageCompression(imageFile, options);
        console.log(`Compressed file size: ${(compressedFile.size / 1024 / 1024).toFixed(2)} MB`);
        return compressedFile;
    } catch (error) {
        console.error("Image compression failed:", error);
        // Fallback to original file if compression fails
        return imageFile;
    }
};
